import type * as models from 'pkg/api/models';
import type { RecurringInterval } from 'pkg/api/models/provider_settings';

export enum PaymentRowType {
	PaymentRowTypeProduct = 'product',
	PaymentRowTypeFee = 'fee',
	PaymentRowTypeDiscount = 'discount',
}

export enum DiscountInvalidType {
	DiscountInvalid = 'invalid',
	DiscountRecurringPaymentZero = 'recurring_payment_zero',
	DiscountRecurringPaymentWithoutInitialPayment = 'recurring_payment_without_initial_payment',
}

export interface LineItem {
	name: string;
	quantity: number;
	amount: number;
	totalListPrice: number;
	totalPrice?: number;
	type: PaymentRowType;
	productPrice: models.productPrice.ProductPrice;
	taxRate: models.taxRate.TaxRate;
	discount: models.discount.Discount;
}

export interface TaxDetail {
	taxRateId: number;
	amount: number;
	taxRate: models.taxRate.TaxRate;
}

export interface PaymentPeriodInfo {
	salePrice: number;
	originalSalePrice: number;
	subTotal: number;
	discountTotal: number;
	taxes: TaxDetail[];
	lineItems: LineItem[];
	recurringCount: number;
	serviceFeeAmount: number;
}

export interface PaymentPreview {
	initialPayment: PaymentPeriodInfo;
	recurringDiscountedPayment: PaymentPeriodInfo;
	recurringPayment: PaymentPeriodInfo;
	recurringInterval: RecurringInterval;
	installmentCount: number;
	recurringDiscountCount: number;
	subscriptionStartAt: number;
	totalInstallmentAmount: number;
	bundleNumber: number;
	delayedSubscriptionStart: boolean;
	recurringIntervalCount: number;
	discountedPayments: number;
	discountInvalidReason: DiscountInvalidType;
	currency: string;
	serviceFeePercent: number;
	paymentOptionId?: number;
}
